<template>
  <header
    id="header"
    class="app-header padding-y-md"
    style="
      background-color: var(--white);
      --button-background: transparent;
      --button-hover-background: transparent;
      --button-margin-bottom: 0;
      --button-padding: var(--spacing-2xs) var(--spacing-md);
      --button-color: var(--fa-md-gravy);
      --button-hover-color: var(--fa-dk-blue);
    "
  >
    <div class="container">
      <div class="wrap-app-header position-relative display-flex flex-items-center flex-content-between size-lg tablet:size-md">
        <slot name="previous">
          <a
            v-if="isShowingCancel"
            href="#"
            aria-label="Let's go back"
            data-balloon-pos="right"
            class="button flat"
            @click.prevent="navigateBack()"
          >
            <font-awesome-icon
              :icon="$v7.solid.faArrowLeft"
              size="xl"
            />
            <span class="sr-only">Let's go back</span>
          </a>
          <site-link
            v-else
            :to="{ name: 'home' }"
            class="wrapper-logo-flag-animated button flat"
            @click.native="$posthog.capture('main_navigation_link_click', { destination: 'home', context: 'limited_main_navigation' })"
          >
            <wa-logo-flag />
            <span class="sr-only">Font Awesome</span>
          </site-link>
        </slot>

        <slot name="title">
          <h1 class="margin-y-0 margin-x-md laptop:margin-x-2xl size-md tablet:size-lg text-truncate">{{ title }}</h1>
        </slot>

        <slot name="action">
          <site-link
            :to="{ name: 'support' }"
            class="button flat"
            aria-label="Support"
            data-balloon-pos="left"
            @click.native="$posthog.capture('support_link_click', { context: 'page_header_limited' })"
          >
            <font-awesome-icon
              :icon="$v7.regular.faHeadset"
              size="xl"
            />
            <span class="sr-only">Support</span>
          </site-link>
        </slot>
      </div>
    </div>
  </header>
</template>

<script>
  export default {
    name: 'PageHeaderLimited',

    props: {
      title: {
        type: String,
        required: true
      },
      isShowingCancel: {
        type: Boolean,
        default: false
      }
    },

    methods: {
      navigateBack() {
        this.$posthog.capture('page_header_limited:go_back_button_click')
        this.$router.go(-1)
      }
    }
  }
</script>
